import type { Theme } from '../../types/theme';

export const togetherTheme: Theme = {
  id: 'together',
  name: 'Together AI',
  description: 'Technical blueprint-style design for open-source AI infrastructure',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/together-ai/DESIGN.md',
  visualKeywords: ['dark', 'blue', 'blueprint', 'technical', 'infrastructure'],
  colors: {
    background: '#0a1929',
    surface: '#0f2847',
    surfaceElevated: '#193251',
    textPrimary: '#ffffff',
    textSecondary: '#7dd3fc',
    textMuted: '#7dd3fc',
    border: '#1e3a5f',
    borderSubtle: '#284469',
    primary: '#3b82f6',
    primaryHover: '#4a91ff',
    primaryActive: '#1d64d8',
    accent: '#3b82f6',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
